export default __webpack_public_path__ + "static/media/Screenshot_18.8c93adf4.png";